import { ApiService } from '../../../types/api';
import type { ApiHandlerContract } from '../../../types/handlers/api';
import type { ProductLookup } from '../types/api';
import type { Product } from '../types/product';

/**
 * A service contract to interact with a specific product via the SparkLayer API.
 */
export interface ProductApiContract {
  get(): Promise<Product>;
}

/**
 * A service to interact with a specific product via the SparkLayer API.
 */
export class ProductApi extends ApiService implements ProductApiContract {
  constructor(
    api: ApiHandlerContract,
    private productLookup: ProductLookup,
  ) {
    super(api);
  }

  public get(): Promise<Product> {
    return this.api.proxy({
      method: 'GET',
      path: '/v2/products/{lookupBy}/{id}',
      params: {
        lookupBy: this.productLookup.by,
        id: this.productLookup.identifier,
      },
    });
  }
}
